// extracted by mini-css-extract-plugin
export default {"innerWrp":"footer_innerWrp__7+F6y","link":"footer_link__uqn4R","icnBuy":"footer_icnBuy__RBsTu","active":"footer_active__yD2VL"};